"use client";

import Link from "next/link";
import { motion } from "framer-motion";

export function Hero() {
  return (
    <section className="relative flex min-h-[85vh] flex-col items-center justify-center overflow-hidden px-4 py-20">
      {/* Fond subtil : grille + gradient radial */}
      <div
        className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,rgb(255_255_255_/0.03)_1px,transparent_1px),linear-gradient(to_bottom,rgb(255_255_255_/0.03)_1px,transparent_1px)] bg-[size:4rem_4rem]"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -top-1/2 left-1/2 h-[80vh] w-[100vw] -translate-x-1/2 rounded-full bg-cyan-500/10 blur-3xl"
        aria-hidden
      />

      <motion.div
        className="relative z-10 max-w-4xl text-center"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl lg:text-7xl">
          <span className="block text-white">Le support client</span>
          <span className="mt-2 block bg-gradient-to-r from-cyan-400 via-emerald-400 to-cyan-400 bg-[length:200%_auto] bg-clip-text text-transparent animate-shimmer">
            réinventé par l&apos;IA
          </span>
        </h1>
        <motion.p
          className="mx-auto mt-6 max-w-2xl text-lg text-slate-400 sm:text-xl"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          Savnally unifie tous vos canaux — Email, WhatsApp, Chat, Meta — avec du tagging
          intelligent, des SLA et une conversion CSAT vers Trustpilot. L&apos;outil le plus
          avancé pour les marchands e-commerce.
        </motion.p>
        <motion.div
          className="mt-10 flex flex-wrap items-center justify-center gap-4"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.4 }}
        >
          <Link
            href="/login"
            className="group relative inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-cyan-500 to-emerald-500 px-8 py-4 text-base font-semibold text-white shadow-[0_0_30px_-5px_rgba(34,211,238,0.5)] transition hover:shadow-[0_0_50px_-5px_rgba(34,211,238,0.6)] focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:ring-offset-2 focus:ring-offset-slate-950"
          >
            Démarrer avec Savnally
          </Link>
          <Link
            href="/login"
            className="inline-flex items-center justify-center rounded-xl border border-white/20 bg-white/5 px-8 py-4 text-base font-medium text-white backdrop-blur-sm transition hover:bg-white/10 hover:border-white/30"
          >
            Se connecter
          </Link>
        </motion.div>
      </motion.div>
    </section>
  );
}
